import { SchemaPath, validate, ValidationError } from '@angular/forms/signals';

export type DateRangeBoundary = Date | string | null;

const toTime = (value: DateRangeBoundary): number | null => (value ? new Date(value).getTime() : null);

/**
 * Signal Forms rule: `start` is not after `end`. Both fields report the `dateRange` error so each one shows it,
 * and both re-validate reactively when either date changes. Missing dates pass.
 */
export function dateRangeOrder(
  start: SchemaPath<DateRangeBoundary>,
  end: SchemaPath<DateRangeBoundary>,
  options: { message?: string } = {}
): void {
  const check = (startValue: DateRangeBoundary, endValue: DateRangeBoundary): ValidationError | undefined => {
    const startTime = toTime(startValue);
    const endTime = toTime(endValue);
    return startTime !== null && endTime !== null && startTime > endTime
      ? { kind: 'dateRange', message: options.message }
      : undefined;
  };

  validate(start, ({ value, valueOf }) => check(value(), valueOf(end)));
  validate(end, ({ value, valueOf }) => check(valueOf(start), value()));
}
